// extracted by mini-css-extract-plugin
module.exports = {"Support":"Support_Support__8G4Al","content":"Support_content__2gbyy"};